import $ from 'jquery';
import _ from 'ext:lodash';
import config from './config.js';
import Map from './Map.js';

var resolver, geocoder;

export default class Api {
	initialize() {

		if(this.loadingPromise) {
			return this.loadingPromise;
		}

		window[config.parameters.callback] = this.loadingCallback.bind(this);

		$.ajax({
			dataType: 'script',
			data: config.parameters,
			url: config.url
		});

		this.loadingPromise = new Promise(function(resolve) {
			resolver = resolve;
		});

		return this.loadingPromise;
	}

	loadingCallback() {
		delete window[config.parameters.callback];
		if(resolver) {
			resolver();
		}
	}

	createMap(el, referralCode, referralSource, promotionName, utmData, altExp, defaultProperties, authoredProperties, conf) {
		return this.initialize().then(() => {
			var mapConfig = _.merge({}, conf, config.map.defaultConfig);
			var map, googleMap;
			var bp = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
			var isMobileProspect = $('.pcl-club-locate').length > 0 && (bp === 'xs' || bp === 'sm' || bp === 'md');

			if (isMobileProspect) { // prospect experience
				mapConfig.disableDefaultUI = true;
			} else {
				mapConfig.zoomControlOptions = {
					position: google.maps.ControlPosition.RIGHT_TOP,
					style: google.maps.ZoomControlStyle.SMALL
				};

				mapConfig.streetViewControlOptions = {
					position: google.maps.ControlPosition.RIGHT_TOP
				};

				mapConfig.mapTypeControlOptions = {
					position: google.maps.ControlPosition.TOP_RIGHT
				};
			}

			googleMap = new google.maps.Map(el, mapConfig);

			map = new Map(googleMap, google.maps, referralCode, referralSource, promotionName, utmData, altExp, defaultProperties, authoredProperties);

			return map;
		});
	}

	getGeocoder() {
		return new Promise((resolve, reject)=> {
			return this.initialize().then(()=> {
				geocoder = new google.maps.Geocoder();
				resolve(geocoder);
			}, reject);
		});
	}

	getApi() {
		return this.loadingPromise.then((resolve)=> {
			resolve(window.google);
		});
	}
}
